import { ISelectType } from "../components/UI/Inputs/AutoComplete";

export interface IInstalledExtension {
  id: string;
  software: ISelectType;
  code: string;
  name: string;
  title: string;
  description: string;
}

export enum Extension {
  EMERGENCY_CARE = "1",
  REFUND = "2",
  TELEPHONE = "4",
  FAQ = "6",
  CARDS = "10",
  MEDIC_GUIDE = "11",
  PAYMENTSLIP = "12",
  COPARTICIPATION = "13",
  IRPF = "14",
  AUTHORIZATIONS = "15",
  WHATSAPP = "19",
  NEWS = "8",
  NOTIFICATIONS = "9",
  HEALTH_PROGRAM = "18",
  EXAMS = "23",
  SCHEDULE = "25",
  EXTERNAL_CALENDAR_BUTTON = "43",
  TRIAGE = "47",
  PIXEON = "50",
  GRACE_PERIOD_CPT = "52",
  TOPMED_SCHEDULE = "51",
  DOCTOR_AGENDA = "60",
  MEDICAL_TRANSFER = "66",
  VUE_MOTION = "69",
  MY_SCHEDULES = "73",
  NEW_SCHEDULE = "74",
  MANAGEMENT_EXAMS = "75",
  FOUR_U_CHAT = "81",
}
